import queries from '@apis/queries';
import UserApi from '@apis/user/UserApi';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useToggleLocationAgreement() {
    const { t } = useTranslation('accountSetting');
    const toast = useToast();
    const queryClient = useQueryClient();
    const { data: user } = useQuery(queries.user.detail());
    const { mutate } = useMutation({
        mutationFn: UserApi.toggleLocationAgreement,
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: queries.user._def, type: 'all' });
            queryClient.invalidateQueries({ queryKey: queries.shop._def, type: 'all' });
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e.response?.data.message || t('toast.unknownError'));
        },
    });

    const toggleLocationAgreement = () => {
        mutate(!user?.locationAgreed);
    };

    return {
        toggleLocationAgreement,
        locationAgreed: user?.locationAgreed,
    };
}

export default useToggleLocationAgreement;
